const initialState = {
  stats: null,
};

export const sellerDashboardStats = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SELLER_DASHBOARD_STATS":
      return { stats: action.payload };
    default:
      return state;
  }
};
